import {
    FetchSiloConfigAI,
    SaveSiloConfigAI,
    SetSiloGroupLoadingStatusAI,
    SiloGroupAT,
    FetchSiloConfigSuccessAI,
    FetchSiloConfigFailureAI,
    SaveSiloConfigSuccessAI,
    SaveSiloConfigFailureAI,
    FetchSiloGroupTypesAI,
    FetchSiloGroupTypesSuccessAI,
    FetchSiloGroupTypesFailureAI,
} from "./actionTypes";

import {SiloGroupState} from "./stateTypes";

export const silogroupAC = {

    fetchSiloConfigRequest: (payload: number): FetchSiloConfigAI => ({
        type: SiloGroupAT.FETCH_SILO_CONFIG_REQUEST,
        payload,
    }),

    fetchSiloConfigSuccess :(configData: any): FetchSiloConfigSuccessAI  => ({
        type: SiloGroupAT.FETCH_SILO_CONFIG_SUCCESS,
        payload: { configData },
    }),

    fetchSiloConfigFailure :(error: any) : FetchSiloConfigFailureAI => ({
        type: SiloGroupAT.FETCH_SILO_CONFIG_FAILURE,
        payload: { error },
    }),


     saveSiloConfigRequest : (devicePk: number, configData: any): SaveSiloConfigAI => ({
        type: SiloGroupAT.SAVE_SILO_CONFIG_REQUEST,
        payload: {
            devicePk,
            payload: configData // Payload structure expected by Saga worker
        },
    }),

     saveSiloConfigSuccess : (response: any) : SaveSiloConfigSuccessAI => ({
        type: SiloGroupAT.SAVE_SILO_CONFIG_SUCCESS,
        payload: { response },
    }),

     saveSiloConfigFailure :(error: any): SaveSiloConfigFailureAI => ({
        type: SiloGroupAT.SAVE_SILO_CONFIG_FAILURE,
        payload: { error },
    }),

     setSiloGroupLoadingStatus: (payload: SiloGroupState["status"]): SetSiloGroupLoadingStatusAI => ({
        type: SiloGroupAT.SET_LOADING_STATE,
        payload,
    }),

    fetchSiloGroupTypes: (): FetchSiloGroupTypesAI => ({
        type: SiloGroupAT.FETCH_SILO_GROUP_TYPE_REQUEST,
    }),

     fetchSiloGroupTypeSuccess :(groupTypes: any): FetchSiloGroupTypesSuccessAI  => ({
        type: SiloGroupAT.FETCH_SILO_GROUP_TYPE_SUCCESS,
        payload: { groupTypes },
    }),

    fetchSiloGroupTypesFailure :(error: any) : FetchSiloGroupTypesFailureAI => ({
        type: SiloGroupAT.FETCH_SILO_GROUP_TYPE_FAILURE,
        payload: { error },
    }),
}


export type SiloGroupActions =
    | FetchSiloConfigAI
    | FetchSiloConfigSuccessAI
    | FetchSiloConfigFailureAI
    | SaveSiloConfigAI
    | SaveSiloConfigSuccessAI
    | SaveSiloConfigFailureAI
    | SetSiloGroupLoadingStatusAI
    | FetchSiloGroupTypesAI
    | FetchSiloGroupTypesSuccessAI
    | FetchSiloGroupTypesFailureAI
